import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import TopNavbar from '../components/TopNavbar/TopNavbar';
import ShowTrips from './ShowTrips/ShowTrips';
import AddNewTrip from './AddNewTrip/AddNewTrip';
import AddCompletedTrip from './AddNewTrip/AddCompletedTrip';
import PERMISSIONS from '../permissions';

function Trips() {
  return (
        <div>
            <TopNavbar 
                title="Trips"
                items={[
                    { label: 'All', path: '/login/trips/all', activePath: '/login/trips/all', permission: PERMISSIONS.VENDOR_TRIP_READ },
                    { label: 'Created', path: '/login/trips/created', activePath: '/login/trips/created', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Booked', path: '/login/trips/booked', activePath: '/login/trips/booked', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Allotted', path: '/login/trips/allotted', activePath: '/login/trips/allotted', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Dispatched', path: '/login/trips/dispatched', activePath: '/login/trips/dispatched', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Completed', path: '/login/trips/completed', activePath: '/login/trips/completed', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Billed', path: '/login/trips/billed', activePath: '/login/trips/billed', permission: PERMISSIONS.VENDOR_TRIP_READ  },
                    { label: 'Cancelled', path: '/login/trips/cancelled', activePath: '/login/trips/cancelled', permission: PERMISSIONS.VENDOR_TRIP_READ  },

                ]}
            />
            
            <Routes>
                <Route path="/" element={<Navigate to="all" replace />} />
                <Route path="all/*" element={<ShowTrips status='ALL' />} /> 
                <Route path="created/*" element={<ShowTrips status='CREATED' />} /> 
                <Route path="booked/*" element={<ShowTrips status='BOOKED' />} />
                <Route path="allotted/*" element={<ShowTrips status='ALLOTTED' />} />
                <Route path="dispatched/*" element={<ShowTrips status='DISPATCHED' />} />
                <Route path="completed/*" element={<ShowTrips status='COMPLETED' />} />
                <Route path="billed/*" element={<ShowTrips status='BILLED' />} />
                <Route path="cancelled/*" element={<ShowTrips status='CANCELLED' />} />
                <Route path="add-new" element={<AddNewTrip status='add-new'  />} />
                <Route path="add-completed" element={<AddCompletedTrip status='add-completed'  />} />
            </Routes>
        </div>
  );
}

export default Trips;